import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['answer'];

  connect() {
    let checked = [];
    this.answerTargets.forEach((answer) => {
      if (answer.checked) {
        checked.push(answer.dataset.answerId);
      }
    });

    document.getElementById('selected_quiz_answer_ids').value = checked.join(',');
  }

  select(event) {
    let checked = [];
    this.answerTargets.forEach((answer) => {
      if (answer.checked) {
        checked.push(answer.dataset.answerId);
      }
    });

    document.getElementById('selected_quiz_answer_ids').value = checked.join(',');
  }
}